import { Chip, Grid, LinearProgress } from "@mui/material";

interface NutritionSumChipProps {
    nutrition: string;
    consumed: number;
    planned: number;

}

const getProgressColor = (percentage: number) => {
    if (percentage < 35) return "error";
    if (percentage < 75) return "warning";
    return "success";
};

const NutritionSumChip = ({ nutrition, consumed, planned }: NutritionSumChipProps) => {
    return (
        <Grid>
            <Chip label={`${nutrition}: ${consumed}/${planned} (${((consumed / planned) * 100).toFixed(0)}%)`} variant="filled" color="info" />
            <LinearProgress variant="determinate" value={(consumed / planned) * 100} sx={{ width: "100%", mt: 1 }} color={getProgressColor((consumed / planned) * 100)} />
        </Grid>
    );
}

export default NutritionSumChip;